import './scss/index.scss'
import { createRoot } from 'react-dom/client'

import Header from './Header'
import Offres from './Offres'
import Projets from './Projets'
import Contact from './Contact'
const root = createRoot(document.querySelector('#root'))

root.render(
    <>
        <div className="container">
            <Header />
            <Offres />
            <Projets />
            <Contact />
        </div>
    </>
)